/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained

access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import Styles from '../../css/ServicerEscrowAnalysis.module.css';

import { Button, createTheme, ThemeProvider } from '@mui/material';
import CalculateApplyAEAView from '../views/CalculateApplyAEAView';
import AEAHistoryView from '../views/AEAHistoryView';
import {
  EscrowAnalysisViews,
  useServicerEscrowAnalysisContext,
} from '../../contexts/ServicerEscrowAnalysisContext';
import { EscrowAnalysisCalculationProvider } from '../../contexts/CalculateEscrowAnalysisContext';
import { useAuthContext } from '../../contexts/AuthContext';
import { AEAHistoryProvider } from '../../contexts/AEAHistoryContext';
import { ApplyAEAProvider } from '../../contexts/ApplyAEAContext';

const theme = createTheme({
  typography: {
    fontFamily: `"Poppins", sans-serif`,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
  },
});

const ServicerEscrowAnalysis = () => {
  const { fullAccess } = useAuthContext();
  const { viewToShow, setViewToShow } = useServicerEscrowAnalysisContext();

  const showCalculateApplyAEAViewButton = () => {
    return (
      <div className={Styles.buttonrow}>
        <Button
          fullWidth
          className={Styles.bluebutton}
          variant='outlined'
          size='large'
          disabled={!fullAccess}
          onClick={() => {
            setViewToShow(EscrowAnalysisViews.CALCULATE_APPLY_AEA_VIEW);
          }}
        >
          {'Calculate / Apply AEA'}
        </Button>
      </div>
    );
  };

  const calculateApplyAEAController = () => {
    return (
      <>
        {viewToShow === EscrowAnalysisViews.MAIN_MENU_VIEW && showCalculateApplyAEAViewButton()}
        {viewToShow === EscrowAnalysisViews.CALCULATE_APPLY_AEA_VIEW && (
          <EscrowAnalysisCalculationProvider>
            <ApplyAEAProvider>
              <CalculateApplyAEAView></CalculateApplyAEAView>
            </ApplyAEAProvider>
          </EscrowAnalysisCalculationProvider>
        )}
      </>
    );
  };

  const aeaHistoryController = () => {
    return (
      <AEAHistoryProvider>
        <AEAHistoryView></AEAHistoryView>
      </AEAHistoryProvider>
    );
  };

  return (
    <ThemeProvider theme={theme}>
      <div className={viewToShow === EscrowAnalysisViews.MAIN_MENU_VIEW ? Styles.menu : ''}>
        {aeaHistoryController()}
        {calculateApplyAEAController()}
      </div>
    </ThemeProvider>
  );
};

export default ServicerEscrowAnalysis;
